/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component, useState } from 'react';
import styles from './index.module.less';
import { getAllOrder, getAvailOrder } from '../../../../services/api';
import { milliFormat, phoneNumFormat, parseDate } from '../../../../utils/tool';
import throttle from 'lodash/throttle'

export default class RechargeHistory extends Component {
    state = {
        tabList: [{
            name: 'process',
            title: "Đang xử lý",
            showed: true
        }, {
            name: 'all',
            title: "Tất cả",
            showed: true
        }, {
            name: 'succeed',
            title: "Thành công",
            showed: false
        }, {
            name: 'failed',
            title: "Thất bại",
            showed: false
        }],
        selectedTab: 'process',
        userInfo: this.props.location.state.userInfo,
        currentOrderList: [],
        orderStatus: {
            '30': 'Đang xử lý',
            '31': 'Thành công',
            '32': 'Thất bại',
            '33': 'Thành công một phần',
        },
        showLoadingModal: false,
        loadingInfo: '',
        pageSize: 6,
        lastMinId: 0,
        noMoreData: false,
    };

    loadStatus = false;

    ref = React.createRef();

    componentDidMount() {
        this.showLoading();
        this.getProcessOrderList();
        const node = this.ref.current;
        this.scrollParent = this.getScrollParent(node);
        if (this.checkVisible(node)) {
            // this.setState({ loading: false });
        } else {
            this.addEvent();
        }
    }

    componentWillUnmount() {
        this.cancelEvent();
    }

    onScroll = throttle(() => {
        const { noMoreData } = this.state;
        const node = this.ref.current;
        if (this.checkVisible(node)) {
            if (!this.loadStatus && !noMoreData) {
                this.getAllOrderList();
            }
        }
    }, 200)

    addEvent = () => {
        const scrollParent = this.scrollParent || window;
        scrollParent.addEventListener('scroll', this.onScroll);
    }

    cancelEvent = () => {
        const scrollParent = this.scrollParent || window;
        scrollParent.removeEventListener('scroll', this.onScroll);
    }


    getScrollParent = (node) => {
        if (!node || node.parentNode === document.documentElement) {
            return null;
        }
        const parentNode = node.parentNode;
        if (parentNode.scrollHeight > parentNode.clientHeight
            || parentNode.scrollWidth > parentNode.clientWidth
        ) {
            return parentNode;
        }
        return this.getScrollParent(parentNode);
    }

    checkVisible = (node) => {
        if (node) {
            const { top, bottom, left, right } = node.getBoundingClientRect();
            return (bottom > 0)
                && (top < window.innerHeight)
                && (left < window.innerWidth)
                && (right > 0);
        }
        return false;
    }

    showLoading = (info) => {
        this.setState({
            loadingInfo: info,
            showLoadingModal: true
        });
    }

    hideLoading = () => {
        this.setState({
            showLoadingModal: false,
            loadingInfo: ''
        });
    }

    getAllOrderList = () => {
        const { userInfo, currentOrderList, lastMinId, pageSize } = this.state;
        console.log('currentOrderList.length=' + currentOrderList.length);
        let data = {
            "app_id": 1,
            "user_id": userInfo.uid,
            "last_min_id": lastMinId + '',
            "page_size": pageSize
        }
        let hearder = {
            "app-id": 1,
            "user-id": userInfo ? userInfo.uid : '',
            "token": userInfo ? userInfo.login_token : '',
        };
        this.loadStatus = true;
        getAllOrder(data, hearder).then(res => {
            if (res && res.code === 0) {
                let minId = res.data[0].id;
                res.data.map((item, index) => {
                    if (item.id < minId) {
                        minId = item.id;
                    }
                });
                if (res.data.length < pageSize) {
                    this.setState({
                        noMoreData: true
                    })
                }
                this.loadStatus = false;
                this.setState({
                    lastMinId: minId,
                    currentOrderList: currentOrderList.concat(res.data)
                });
            }
            this.hideLoading();
        });
    }

    getProcessOrderList = () => {
        const { userInfo } = this.state;
        getAvailOrder({
            "app_id": 1,
            "user_id": userInfo.uid,
        }, {
                "app-id": 1,
                "user-id": userInfo ? userInfo.uid : '',
                "token": userInfo ? userInfo.login_token : '',
            }).then(res => {
                if (res && res.code === 0) {
                    this.setState({
                        currentOrderList: res.data
                    });
                }
                this.hideLoading();
            });
    }


    bindTabItem = (name) => {
        this.setState({
            currentOrderList: [],
            noMoreData: false
        }, () => {
            this.showLoading();
            if (name) {
                switch (name) {
                    case 'process':
                        this.getProcessOrderList();
                        break;
                    case 'all':
                        this.getAllOrderList();
                        break;
                    default:
                        this.getProcessOrderList();
                        break;
                }
                this.setState({ selectedTab: name });
            }
        });
    }
    render() {
        const { tabList, selectedTab, currentOrderList, orderStatus, showLoadingModal, loadingInfo, noMoreData } = this.state;

        const renderContent = () => {
            return currentOrderList.map((item, index) => {
                console.log("index:" + index + '  id:' + item.order_code);
                return <div ref={index == currentOrderList.length - 3 ? this.ref : null} className={styles.historyItem} key={index}>
                    <div className={styles.historyTitle}>
                        <span className={styles.orderNum}>{item.order_code}</span>
                        <span className={styles.orderDate}>{parseDate(item.create_time)}</span>
                    </div>
                    <div className={styles.historyContent}>
                        <label>Số điện thoại: <span>{`${item.topup_phone} (${item.vendor})`}</span></label>
                        <label>Mệnh giá：<span>{milliFormat(item.topup_amount)}đ</span></label>
                        <label>Số tiền thanh toán：<span>{milliFormat(item.product_price)}đ</span></label>
                        <label>Trạng thái：<span>{`${item.status}${orderStatus[item.status] ? `,${orderStatus[item.status]}` : ''}`}</span></label>
                        <label>Thời gian nạp：<span>{parseDate(new Date(item.update_time))}</span></label>
                        {item.remark ? <label>Mô tả：<span>{item.remark}</span></label> : null}
                    </div>
                </div>
            });
        }

        return <>
            <div className={styles.tab_wrapper}>
                <div className={styles.tab_list}>
                    <ul className={styles.tab}>
                        {tabList.map(item => (item.showed ? <li key={item.name} className={`${styles.tab_item} ${selectedTab === item.name ? styles.tab_active : ''}`} data-type={item.name} onClick={this.bindTabItem.bind(null, item.name)}>{item.title}</li> : null))}
                    </ul>
                </div>
                {renderContent()}
                {noMoreData ? <div className={styles.moreDataWrapper}>
                    <hr />
                    Không còn dữ liệu thêm
                </div> : null}
            </div>
            {showLoadingModal ? <div className={styles.loadingModal}>
                <div className={styles.loading}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                {loadingInfo ? <div className={styles.loadingTxt}>{loadingInfo}</div> : null}
            </div> : null}
        </>
    }
}